var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-body" }, [
    _c("div", { staticClass: "fields-border" }, [
      _c("div", { staticClass: "form-group row padding-field" }, [
        _c("div", { staticClass: "col-sm-3" }, [
          _c("strong", [_vm._v(_vm._s(_vm.T.profileUsername))])
        ]),
        _c(
          "div",
          { staticClass: "col-sm-9 field-data" },
          [
            _c("omegaup-user-username", {
              attrs: {
                classname: _vm.profile.classname,
                username: _vm.profile.username
              },
              scopedSlots: _vm._u([
                {
                  key: "username-url",
                  fn: function() {
                    return [_vm._v(_vm._s(_vm.urlUsername))]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        )
      ]),
      _vm.profile.is_own_profile || !_vm.profile.is_private
        ? _c("div", { staticClass: "form-group row padding-field" }, [
            _c("div", { staticClass: "col-sm-3" }, [
              _c("strong", [_vm._v(_vm._s(_vm.T.profile))])
            ]),
            _c(
              "div",
              {
                staticClass: "col-sm-9 field-data",
                attrs: { "data-user-name": "" }
              },
              [_vm._v(" " + _vm._s(_vm.profile.name) + " ")]
            )
          ])
        : _vm._e(),
      _vm.profile.is_own_profile
        ? _c("div", { staticClass: "form-group row padding-field" }, [
            _c("div", { staticClass: "col-sm-3" }, [
              _c("strong", [_vm._v(_vm._s(_vm.T.profileEmail))])
            ]),
            _c("div", { staticClass: "col-sm-9 field-data" }, [
              _vm._v(" Primary: "),
              _c("strong", { attrs: { "data-email": "" } }, [
                _vm._v(_vm._s(_vm.profile.email))
              ])
            ])
          ])
        : _vm._e(),
      _vm.profile.is_own_profile || !_vm.profile.is_private
        ? _c("div", [
            _c("div", { staticClass: "form-group row padding-field" }, [
              _c("div", { staticClass: "col-sm-3" }, [
                _c("strong", [_vm._v(_vm._s(_vm.T.profileCountry))])
              ]),
              _c(
                "div",
                {
                  staticClass: "col-sm-9 field-data",
                  attrs: { "data-user-country": "" }
                },
                [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.profile.country === "xx"
                          ? _vm.T.countryNotSet
                          : _vm.profile.country
                      )
                    )
                  ])
                ]
              )
            ]),
            _c("div", { staticClass: "form-group row padding-field" }, [
              _c("div", { staticClass: "col-sm-3" }, [
                _c("strong", [_vm._v(_vm._s(_vm.T.profileState))])
              ]),
              _c(
                "div",
                {
                  staticClass: "col-sm-9 field-data",
                  attrs: { "data-user-state": "" }
                },
                [_c("strong", [_vm._v(_vm._s(_vm.profile.state))])]
              )
            ]),
            _c("div", { staticClass: "form-group row padding-field" }, [
              _c("div", { staticClass: "col-sm-3" }, [
                _c("strong", [_vm._v(_vm._s(_vm.T.profileSchool))])
              ]),
              _c(
                "div",
                {
                  staticClass: "col-sm-9 field-data",
                  attrs: { "data-user-school": "" }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "/schools/profile/" + _vm.profile.school_id + "/"
                      }
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.profile.school))])]
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "form-group row padding-field" }, [
              _c("div", { staticClass: "col-sm-3" }, [
                _c("strong", [_vm._v(_vm._s(_vm.T.profileGraduationDate))])
              ]),
              _c(
                "div",
                {
                  staticClass: "col-sm-9 field-data",
                  attrs: { "data-graduation-date": "" }
                },
                [_c("strong", [_vm._v(_vm._s(_vm.graduationDate))])]
              )
            ]),
            _c("div", { staticClass: "form-group row padding-field" }, [
              _c("div", { staticClass: "col-sm-3" }, [
                _c("strong", [_vm._v(_vm._s(_vm.T.profileAuthorRank))]),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.CategoriesFeatureGuideURL,
                      target: "_blank"
                    }
                  },
                  [
                    _c("em", {
                      staticClass: "glyphicon glyphicon-question-sign"
                    })
                  ]
                )
              ]),
              _c("div", { staticClass: "col-sm-9 field-data" }, [
                _c(
                  "strong",
                  [
                    _vm.rank
                      ? _c("omegaup-user-username", {
                          attrs: {
                            classname: _vm.profile.classname,
                            username: _vm.rank
                          }
                        })
                      : _c("p", [_vm._v(_vm._s(_vm.T.authorRankUnranked))])
                  ],
                  1
                )
              ])
            ])
          ])
        : _vm._e()
    ]),
    _vm.profile.is_own_profile || !_vm.profile.is_private
      ? _c(
          "a",
          { attrs: { href: "/submissions/" + _vm.profile.username + "/" } },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.ui.formatString(_vm.T.wordsSeeLatestSubmissions, {
                    username: _vm.profile.username
                  })
                ) +
                " "
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }